import { FETCH_CUSTOMER } from './../constants';
import { handleActions } from "redux-actions"

export const customers  = handleActions(
  {
    [ FETCH_CUSTOMER ]: (state, action) => (action.payload === undefined) ? [...state] : [...state,  action.payload ]
  }, []
)